import React from "react";

function LinkTooltip(
                         className,
                         content,
                         src,
                         href,
                         width,
                         height,
                         placement,
                         disabled
                     ) {
    return (
        <>
            {disabled === false ? (
                    <a href={href}>
                        <img src={src} width={width} height={height} alt={content}/>
                    </a>
            ) : (
                <img
                    className="imageDisable"
                    src={src}
                    width={width}
                    height={height}
                    alt={content}
                />
            )}
        </>
    );
}

export default LinkTooltip;
